import i18n from '@/i18n/i18n'
import FarmerRequiredDocumentsService from '@/services/public/FarmerRequiredDocumentsService.js'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const state = {
  required_documents: [],
  farmer_fullname: null,
  application_status: null,
  kyc_document: {},
  digital_signable_document: null
}

export const mutations = {
  SET_REQUIRED_DOCUMENTS(state, required_documents) {
    state.required_documents = required_documents.data.data
    state.farmer_fullname = required_documents.data.farmer_fullname
    state.application_status = required_documents.data.application_status
  },
  SET_KYC_DOCUMENT(state, kyc_document) {
    state.kyc_document =
      kyc_document.data.length > 0 || kyc_document.data
        ? kyc_document.data.data
        : {}
    state.farmer_fullname = kyc_document.data.farmer_fullname
    state.application_status = kyc_document.data.application_status
  },
  SET_DIGITAL_SIGNABLE_DOCUMENT(state, digital_signable_document) {
    state.digital_signable_document = digital_signable_document
  }
}

export const actions = {
  checkNin({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      FarmerRequiredDocumentsService.checkNin(params.applicationId, params.tckn)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t(
              'store.public.farmer_required_documents.identity_verification_error'
            )
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getRequiredDocuments({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      FarmerRequiredDocumentsService.getRequiredDocuments(params.applicationId)
        .then(response => {
          commit('SET_REQUIRED_DOCUMENTS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t(
              'store.public.farmer_required_documents.required_documents_error'
            )
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  uploadPublicDocument({ commit, dispatch }, data) {
    const { applicationId, file } = data
    const formData = new FormData()

    formData.append('file', file.file)
    formData.append('type', file.type)

    return new Promise((resolve, reject) => {
      FarmerRequiredDocumentsService.uploadPublicDocument(
        applicationId,
        formData
      )
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  sendDocumentWaiting({ commit, dispatch }, applicationId) {
    return new Promise((resolve, reject) => {
      FarmerRequiredDocumentsService.sendDocumentWaiting(applicationId)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t(
              'store.public.farmer_required_documents.send_document_waiting_error'
            )
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  uploadPublicKycDocument({ commit, dispatch }, data) {
    const { applicationId, file } = data
    const formData = new FormData()

    formData.append('file', file.file)
    formData.append('type', file.type)

    return new Promise((resolve, reject) => {
      FarmerRequiredDocumentsService.uploadKycDocument(applicationId, formData)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  sendDocumentKycApproval({ commit, dispatch }, applicationId) {
    return new Promise((resolve, reject) => {
      FarmerRequiredDocumentsService.sendKycApproval(applicationId)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t(
              'store.public.farmer_required_documents.send_document_waiting_error'
            )
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getRequiredKycDocument({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      FarmerRequiredDocumentsService.getRequiredDKycocuments(
        params.applicationId
      )
        .then(response => {
          commit('SET_KYC_DOCUMENT', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t(
              'store.public.farmer_required_documents.required_documents_error'
            )
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getDigitalSignableDocument({ commit, dispatch }, { documentHash }) {
    return new Promise((resolve, reject) => {
      FarmerRequiredDocumentsService.getDigitalSignableDocument(documentHash)
        .then(response => {
          commit('SET_DIGITAL_SIGNABLE_DOCUMENT', response.data.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }

          dispatch('notification/add', notification, {
            root: true
          })

          reject(err)
        })
    })
  },
  viewDigitalSignableDocument({ dispatch }, { documentHash }) {
    return new Promise((resolve, reject) => {
      FarmerRequiredDocumentsService.viewDigitalSignableDocument(documentHash)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }

          dispatch('notification/add', notification, {
            root: true
          })

          reject(err)
        })
    })
  },
  sendDigitalSignatureSmsToFarmer({ dispatch }, { applicationHash, documentId }) {
    return new Promise((resolve, reject) => {
      FarmerRequiredDocumentsService.sendDigitalSignatureSmsToFarmer(applicationHash, documentId)
        .then(response => {
          if (response.success === true) {
            const notification = {
              type: 'success',
              message: t('store.retailer.required_documents.sms_successfully_sent')
            }
            dispatch('notification/add', notification, {
              root: true
            })
          }
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  confirmDigitaleSignableDocument({ dispatch }, { documentHash }) {
    return new Promise((resolve, reject) => {
      FarmerRequiredDocumentsService.confirmDigitaleSignableDocument(documentHash)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  verifyDigitalSignature({ dispatch }, { applicationHash, documentId, code }) {
    return new Promise((resolve, reject) => {
      FarmerRequiredDocumentsService.verifyDigitalSignature(applicationHash, documentId, code)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
